import React, { Component } from 'react';
import styles from './detail.module.scss';
import classnames from 'classnames';

import { Tabs } from 'antd';
//import 'antd/es/tabs/style/css';

import { strings } from '../../components/utils/translations';
import API from '../../components/utils/API';
import { Utils } from '../../components/utils/utils';
import CloseIcon from '../../img/icons/closeIcon';
import DoorStatusPill from '../../components/DoorStatusPill/DoorStatusPill'
import VRExpirationTag from '../../components/VRExpirationTag/VRExpirationTag'

import BoxIcon from './../../img/icons/box-icon.svg';
import InfiniteIcon from './../../img/icons/infinite-icon.svg';
import RecurrenteIcon from './../../img/icons/recurrente.svg';
import RecurrenteRedIcon from './../../img/icons/recurrente-red.svg';
import TemporaryIcon from './../../img/icons/temporal.svg';
import TemporaryRedIcon from './../../img/icons/temporal-red.svg';
import LockIcon from './../../img/icons/lock_closed.svg';
import LockOpenIcon from './../../img/icons/lock_open.svg';
import ProximityIcon from './../../img/icons/proximity-icon.svg';
import EthernetIcon from './../../img/icons/ethernet-icon.svg';

import { ReactComponent as ActivityIcon } from '../../img/icons/list.dash.svg'
import { ReactComponent as RemotesIcon } from '../../img/icons/person.2.fill.svg'

import DetailActivity from './detailActivity';
import DetailRemotes from './detailRemotes';

const GUEST_UNLIMITED = 1;
const GUEST_TEMPORARY = 2;
const GUEST_RECURRENT = 3;

const CIRCUIT_OPENED = 'CIRCUIT_OPENED';
const CIRCUIT_CLOSED = 'CIRCUIT_CLOSED';

const IS_OPENED_TIMER 				= 6 * 1000; // ms
const IS_OPENED_TIMER_ON_TRIGGER 	= 3 * 1000; // ms

export default class DetailDoor extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
		{
            door: props.door,
            house: props.house,
            doorName: props.door ? props.door.name : '',
            onClickClose: props.onClickClose,
            openFeaturesDetailsModal: props.openFeaturesDetailsModal,
            roleType: props.door ? props.door.roleType : '',

            isOpened: null,
            canTriggerDoorNow: false,
            proximityEnabled: false,
			
			isVRexpired: null
        }

        this.startPermissionTimer = null;
        this.endPermissionTimer = null;

        this.gettingDoorOpened = false;

        this.setCanTriggerDoorNow.bind(this);
        this.getDoorOpened.bind(this);
        this.getProximityEnabled.bind(this);
    }

    componentDidMount()
    {
        this.setCanTriggerDoorNow();
        //this.getDoorOpened();
    }

	componentWillReceiveProps(nextProps)
	{		
		let newState = {}

		if (nextProps.door != null)
		{
            newState.door = nextProps.door
			newState.doorName = nextProps.door.name
			newState.roleType = nextProps.door.roleType
		}
		
		if (nextProps.house != null)
		{
			newState.house = nextProps.house
		}
			
		this.setState(newState, () =>
		{
			this.setCanTriggerDoorNow();
	        //this.getDoorOpened();
		})
    }

    componentWillUnmount()
	{
		if (this.startPermissionTimer != null)
			clearTimeout(this.startPermissionTimer);

		if (this.endPermissionTimer != null)
			clearTimeout(this.endPermissionTimer);

		if (this.isOpenedTimer != null)
			clearInterval(this.isOpenedTimer);

		if (this.isOpenedTimerOnTrigger != null)
			clearInterval(this.isOpenedTimerOnTrigger);
	}

	render()
	{
		if (this.state.door == null) return (<div className={ classnames([styles.detailBlock, this.props.isOpen && styles.isOpen]) }></div>)
		
        const { TabPane } = Tabs;
        const houseName = this.state.house.name;

        var canTriggerDoorIcon = <img className={styles.icon} src={InfiniteIcon} alt=""/>;

		if (this.props.door.roleType == 'guest')
		{
			var permissionType = Utils.getGuestPermissionType(this.props.door.myPermission);

			if (permissionType == GUEST_TEMPORARY)
				canTriggerDoorIcon = (this.state.canTriggerDoorNow) ?
                    <img className={styles.icon} src={TemporaryIcon} alt="Permiso Temporal" /> :
					<img className={styles.icon} src={TemporaryRedIcon} alt="Permiso Temporal" />;
			else if (permissionType == GUEST_RECURRENT)
				canTriggerDoorIcon = (this.state.canTriggerDoorNow) ?
                    <img className={styles.icon} src={RecurrenteIcon} alt="Permiso Recurrente" /> :
					<img className={styles.icon} src={RecurrenteRedIcon} alt="Permiso Recurrente" />;
			else if (permissionType == null)
				canTriggerDoorIcon = null;
        }

        var isOpenedIconView = null;
        if (this.props.door.roleType == 'guest')
		{
            let icon = (this.state.isOpened) ? LockOpenIcon : LockIcon;
			isOpenedIconView = <img className={styles.icon} src={icon} alt=""/>;
        }

        var proximityView = null;
		if (this.props.door.roleType != 'guest' && this.state.proximityEnabled)
		{
			proximityView = <img className={styles.icon} src={ProximityIcon} alt=""/>;
		}

		return (
	        <div className={ classnames([styles.detailBlock, this.props.isOpen && styles.isOpen]) }>
				<div className={styles.topBarDetail}>
					<div>
						<span className={styles.label}>{houseName}</span>
						<h3 className={styles.title}>{this.state.doorName}</h3>
					</div>
					
					<div className={styles.iconsContainer}>
						<VRExpirationTag
							door={this.props.door}
							containerStyle={styles.vrExpirationTag}
							onIsExpiredChanged={this.onIsExpiredChanged.bind(this)}
						/>
						<DoorStatusPill
							door={this.state.door}
						/>
						<CloseIcon className={styles.closeIcon} size="12" onClick={this.state.onClickClose} />
					</div>
				</div>

				<div className={classnames("tabsContainer", styles.tabsContainer)}>
					<Tabs defaultActiveKey="Activity">
						<TabPane
							tab={<>
								<ActivityIcon />
								{ strings('activity') }
							</>}
							key={ strings('activity') }
						>
							<DetailActivity
								id={this.props.door.id}
								door={this.props.door}
								doorName={this.state.doorName}
								isDetailOpen={this.props.isOpen}
								isVRexpired={this.state.isVRexpired}
							/>
						</TabPane>
						<TabPane
							tab={<>
								<RemotesIcon />
								{ strings('remotes') }
							</>}
							key={ strings('remotes') }
						>
							<DetailRemotes
								door={this.props.door}
								roleType={this.state.roleType}
								openUserRemoteDetail={this.openUserRemoteDetail.bind(this)}
								openPermissions={this.props.openPermissions}
								onDeletePermission={this.onDeletePermission.bind(this)}
							/>
						</TabPane>
					</Tabs>
				</div>
	        </div>
		)
	}

    setCanTriggerDoorNow()
	{
		if (this.props.door == null) return
		
		var canTrigger = false;
		var myPermission = this.props.door.myPermission;
		var roleType = this.props.door.roleType;

		var canTrigger = Utils.canTriggerDoorNow(roleType, myPermission);

		if (this.props.door.roleType == 'guest')
		{
			if (canTrigger.startTimerSecs != null && canTrigger.startTimerSecs <= (24*3600))
			{
				if (this.startPermissionTimer != null) clearTimeout(this.startPermissionTimer);
				this.startPermissionTimer = setTimeout(() => { this.setCanTriggerDoorNow(); }, canTrigger.startTimerSecs * 1000);
			}

			if (canTrigger.endTimerSecs != null && canTrigger.endTimerSecs <= (24*3600))
			{
				if (this.endPermissionTimer != null) clearTimeout(this.endPermissionTimer);
				this.endPermissionTimer = setTimeout(() => { this.setCanTriggerDoorNow(); }, canTrigger.endTimerSecs * 1000);
			}
		}

        this.setState({ canTriggerDoorNow: canTrigger.canTrigger });
    }

    getDoorOpened()
	{
		if (this.props.door == null) return
		
		// if (this.props.isVisible && !this.gettingDoorOpened)
		// {
			this.gettingDoorOpened = true;

			API.getInstance()
			.getDoorEventsAndActions(
			{
				doorId: this.props.door.id,
				limit: 1
			})
			.then(response =>
			{
				if (response.data.eventsAndActions.sensor.length > 0)
				{
					let lastSensor = response.data.eventsAndActions.sensor[0];

					if (lastSensor.eventType === CIRCUIT_OPENED)
						this.setIsOpened(true);
					else if (lastSensor.eventType === CIRCUIT_CLOSED)
						this.setIsOpened(false);
				}

				this.gettingDoorOpened = false;
			})
			.catch(error =>
			{
				this.gettingDoorOpened = false;
				console.log(error);
			});
		// }
    }

    setIsOpened(isOpened)
	{
		if (this.state.isOpened != isOpened)
		{
			this.setState({ isOpened });
		}
    }

    getProximityEnabled()
	{
		// Proximity.loadProximityDoor(this.props.door.id, (savedDoor) =>
        // {
		// 	let proximityEnabled = (savedDoor != null && savedDoor.doorId != null);

		// 	if (this.state.proximityEnabled !== proximityEnabled)
		// 		this.setState({ proximityEnabled });
        // });
	}

    openUserRemoteDetail()
    {
        this.setState({ openUserRemoteDetail: !this.state.openUserRemoteDetail})
    }
	
	onDeletePermission()
	{
		if (this.props.onDeletePermission)
			this.props.onDeletePermission()
	}

	transferredAdminAndGetHouses()
	{
		this.props.navigator.pop();
		if (this.props.transferredAdminAndGetHouses != null)
			this.props.transferredAdminAndGetHouses();
    }
	
	onIsExpiredChanged({ isExpired })
	{
		if (isExpired != this.state.isVRexpired)
			this.setState({ isVRexpired: isExpired })
	}
}